import * as yup from 'yup';

export const BvnValidationSchema = yup.object({
	directorBvn: yup
		.string()
		.min(11, 'BVN must be at least 11 characters')
		.max(11, 'BVN must be at most 11 characters')
		.required('BVN is required'),
	directorDob: yup.string().required('Date of birth is required'),
});
